const getCategoryData = ({ categoryDataId, categoryDataCatalog, categories, }) => {
    return categories.find((c) => c.data.catalog === categoryDataCatalog && c.data.id === categoryDataId);
};
export default getCategoryData;
